<template>
  <div class="form-group">
    <div class="d-flex justify-content-between">
      <label v-if="label" class="form-label text-muted">
        {{ label }} <i v-if="required" class="text-danger">*</i>
      </label>
      <slot name="labelContentEnd"></slot>
    </div>
    <select
      :disabled="readOnly"
      class="form-select"
      v-model="model.$model"
      :class="{ 'is-invalid': model.$error }"
      @change="onChange($event)"
      :id="selectId"
    >
      <option v-if="placeholder" disabled value="">{{ placeholder }}</option>
      <option
        v-for="(item, index) in options"
        v-bind:key="'option_' + index"
        :value="item[propertyForValue]"
      >
        {{ item[propertyForText] }}
      </option>
    </select>
    <div class="invalid-feedback">
      <small>{{ errorMsg }}</small>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    model?: any;
    selectId?: string;
    options?: any[];
    propertyForValue?: string;
    propertyForText?: string;
    label?: string;
    errorMsg?: string;
    placeholder?: string;
    readOnly?: boolean;
    required?: boolean;
  }>(),
  {
    model: () => ({}),
    selectId: "",
    options: () => [],
    propertyForValue: "id",
    propertyForText: "title",
    label: "",
    errorMsg: "Por favor, selecione uma opção",
    placeholder: "Escolha uma opção",
    readOnly: false,
    required: false,
  },
);

const emit = defineEmits<{
  selectChanged: [value: string];
}>();

const onChange = (event: Event) => {
  emit("selectChanged", (event.target as HTMLSelectElement).value);
};
</script>
